/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import PropTypes from 'prop-types';
import ImageIcon from 'mdi-react/ImageIcon';
import VideoIcon from 'mdi-react/PlayCircleOutlineIcon';
import graphqlPropTypes from '@prisjakt/graphql-proptypes';
import { AppContext } from '@prisjakt/ui-app-context';

import { connect } from 'react-redux';
import ProductMediaLightbox from '../product-media-lightbox';
import MediaCounter from './media-counter';
import { ProductMediaFragment } from '../../../../types';

import productMediaActions from '../../actions/media';

import * as S from './styles';

class ProductMedia extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { show: false };
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  hasLightboxContent() {
    return Boolean(this.props.media.large || this.props.media.video);
  }

  open() {
    if (!this.hasLightboxContent()) {
      return;
    }

    this.setState({ show: true });
    this.props.productMediaOpen(this.props.position);
  }

  close = () => {
    this.setState({ show: false });
  };

  render() {
    const { className, media, category, name, position } = this.props;
    const { show } = this.state;

    return (
      <>
        {show && (
          <ProductMediaLightbox
            media={media}
            position={position}
            close={this.close}
          />
        )}
        <S.ProductMedia
          className={className}
          isFallbackImage={!media.first}
          more={media && media.images}
          onClick={this.open}
          data-test="ProductMedia"
          data-test-has-lightbox-content={this.hasLightboxContent()}
        >
          <S.FirstImage>
            <img src={media.first || (category && category.logo)} alt={name} />
          </S.FirstImage>
          {(media.images || media.videos) && (
            <S.Counters>
              <MediaCounter icon={ImageIcon} mediaList={media.images} />
              <MediaCounter icon={VideoIcon} mediaList={media.videos} />
            </S.Counters>
          )}
        </S.ProductMedia>
      </>
    );
  }
}

const { shape, bool, number, string, func } = PropTypes;
ProductMedia.propTypes = {
  className: string,
  media: graphqlPropTypes(ProductMediaFragment),
  show: bool,
  position: number,
  name: string,
  productMediaOpen: func,
  productMediaSetPosition: func,
  category: shape({
    logo: string,
  }),
};

ProductMedia.defaultProps = {
  className: undefined,
  position: 0,
  show: false,
  name: '',
  productMediaOpen: () => {},
  productMediaSetPosition: () => {},
  category: undefined,
  media: {
    videos: null,
  },
};

ProductMedia.contextType = AppContext;

export default connect(() => ({}), productMediaActions)(ProductMedia);
